export default "__VITE_PUBLIC_ASSET__83140352__"